import React, {useContext, useEffect, useState} from 'react';
import {SectionsContext} from "../contexts/SectionsProvider";
import {Col, ListGroup, ListGroupItem, Row} from "react-bootstrap";
import {FaCalendarAlt, FaCheck, FaEnvelopeOpenText, FaEuroSign, FaUpload, FaUser} from "react-icons/fa";
import {useWindowSize} from "../hooks/useWindowSize";
import {buildStyles, CircularProgressbar} from 'react-circular-progressbar';
import "react-circular-progressbar/dist/styles.css";
import character from "../../assets/images/housey-show.svg"
import {MortgageContext} from "../contexts/MortgageProvider";
import {Link} from "react-router-dom";

function Dashboard(props) {
    const sectionsContext = useContext(SectionsContext)
    const mortgageContext = useContext(MortgageContext)
    const [w, h] = useWindowSize()
    const [state, setState] = useState({
        overlay: false,
        openPanels: ["1"],
        position: 'top'
    })
    useEffect(() => {
        //context.sidebar.close()
        setTimeout(() => {

            setState({...state, position: ''})
        }, 50)

    }, [])

    const mortgageOverviewItems = [
        {
            icon: <FaEnvelopeOpenText/>,
            label: 'Status',
            value: 'Active'
        },
        {
            icon: <FaEuroSign/>,
            label: 'Mortgage Amount',
            value: '€ ' + mortgageContext.mortgage.requirement.loanRequired.toLocaleString('en-US')
        },
        {
            icon: <FaCalendarAlt/>,
            label: 'Mortgage Term',
            value: mortgageContext.mortgage.requirement.loanTerm + ' years'
        }
    ]

    const percentToStatus = (percent) => {
        switch (percent) {
            case 100:
                return 'Completed'
            case 0:
                return 'Not Started'
            default:
                if (percent > 90) return 'Almost Finished'
                return 'Active'
        }
    }
    let applyTotal = []
    const mortDetails = sectionsContext.sections.apply.filter(i => ![1,2].includes(i.applicant))
    const mortPercents = mortDetails.map(s => s.progress).reduce((partialSum, a) => partialSum + a, 0);
    const mortTotal = mortPercents / mortDetails.length
    applyTotal.push(mortTotal)

    const app1details = sectionsContext.sections.apply.filter(i => i.applicant === 1)
    const app1percents = app1details.map(s => s.progress).reduce((partialSum, a) => partialSum + a, 0);
    const app1total = app1percents / app1details.length
    const app1name = mortgageContext.mortgage.applicant1.firstName || 'Applicant 1'
    applyTotal.push(app1total)

    const applicationStatusItems = [
        {
            icon: <FaCheck/>,
            label: 'Mortgage Requirements',
            value: percentToStatus(mortTotal),
            link: 'apply'
        },
        {
            icon: <FaUser/>,
            label: app1name + '\'s Personal Details',
            value: percentToStatus(app1total),
            link: 'apply-1'
        }
    ]
    if (mortgageContext.mortgage.twoApplicants) {
        const app2details = sectionsContext.sections.apply.filter(i => i.applicant === 2)
        const app2percents = app2details.map(s => s.progress).reduce((partialSum, a) => partialSum + a, 0);
        const app2total = app2percents / app2details.length
        const app2name = mortgageContext.mortgage.applicant2.firstName || 'Applicant 2'
        applicationStatusItems.push({
            icon: <FaUser/>,
            label: app2name + '\'s Personal Details',
            value: percentToStatus(app2total),
            link: 'apply-2'
        })
        applyTotal.push(app2total)
    }
    let applyTotalPercent = Math.floor(applyTotal.reduce((partialSum, a) => partialSum + a, 0) / applyTotal.length)

    const uploadSectionToStatus = (secs)=>{
        let len = secs.length // total uploads needed
        let list = secs.map(sec=>{
            let uploaded = mortgageContext.mortgage.uploads.filter(i=>i.stage === 'APPLY' && i.section === sec.name)
            if (uploaded.length){
                let accepted = uploaded.filter(i=>i.status === 'ACCEPTABLE')
                let rejected = uploaded.filter(i=>i.status === 'REJECTED')
                let pending = uploaded.filter(i=>i.status === 'PENDING')
                if (accepted.length === uploaded.length){
                    return "Acceptable"
                }
                else if (rejected.length) {
                    return "Rejected"
                }
                else if (pending.length){
                    return "Pending"
                }
            }
            return "Outstanding"
        })
        const counts = {};
        list.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });
        return Object.keys(counts).map(k=>{
            return counts[k] + " " + k
        })
    }

    const app1uploads = uploadSectionToStatus( sectionsContext.sections.uploads.filter(i=>i.applicant === 1) )



    const uploadOverviewItems = [
        {
            icon: <FaUser/>,
            label: 'Kevin\'s Uploads',
            value: <div className="text-end">{app1uploads.map(i=><div key={i}>{i}</div>)}</div>,
            link: 'upload-1'
        }]
    if (mortgageContext.mortgage.twoApplicants){
        uploadOverviewItems.push({
                icon: <FaUser/>,
                label: 'Ruth\'s Uploads',
                value: 'Not Started',
                link: 'upload-2'
            })
    }
    uploadOverviewItems.push({
            icon: <FaUpload/>,
            label: 'Other Uploads',
            value: <div className="text-end">5 Outstanding<br/> 3 Accpeted <br/> 1 Returned</div>,
            link: 'upload'
        })
    return (
        <div className={`question-transition ${state.position}`}>
            <div className="transitionable delay-2">
                <h5 className="mt-3 text-primary-dull">Mortgage Overview</h5>
                <hr/>
                <Row>

                    <Col>

                        <ListGroup>

                            {
                                mortgageOverviewItems.map(i => {
                                    return (

                                        <ListGroupItem key={i.label} className="d-flex bg-smoke  text-primary-dull">
                                                <span className="me-3">
                                                      {i.icon}
                                                </span>
                                            {i.label}
                                            <span className="ms-auto">  {i.value}</span>
                                        </ListGroupItem>

                                    )
                                })
                            }
                        </ListGroup>

                    </Col>
                    <Col xs={4} className="text-center d-none d-sm-block d-md-none d-lg-block">

                        <img className="w-50" src={character}/>
                    </Col>
                </Row>
            </div>
            <div className="transitionable delay-3">
                <h5 className="mt-5 text-primary-dull">Application Status</h5>
                <hr/>
                <Row>

                    <Col>

                        <ListGroup>

                            {
                                applicationStatusItems.map(i => {
                                    return (

                                        <ListGroupItem as={Link} to={i.link} key={i.label} className="d-flex bg-smoke  text-primary-dull">
                                                <span className="me-3">
                                                      {i.icon}
                                                </span>
                                            {i.label}
                                            <span className="ms-auto">  {i.value}</span>
                                        </ListGroupItem>

                                    )
                                })
                            }
                        </ListGroup>

                    </Col>
                    <Col xs={4} className="d-none d-sm-block d-md-none d-lg-block">
                        <div className="d-flex flex-column ">
                            <div className='d-flex justify-content-center'>
                                <div className="w-50">
                                    <CircularProgressbar
                                        value={applyTotalPercent}
                                        text={applyTotalPercent + '%'}
                                        circleRatio={0.75}
                                        styles={buildStyles({
                                            rotation: 1 / 2 + 1 / 8,
                                            // strokeLinecap: "butt",
                                            trailColor: "#eee"
                                        })}
                                    />
                                </div>

                            </div>
                            <div className="text-center small">
                                Completed {applyTotalPercent}% of your application
                            </div>

                        </div>
                    </Col>
                </Row>
            </div>
            <div className="transitionable delay-4">
                <h5 className="mt-5 text-primary-dull">Uploads Overview</h5>
                <hr/>
                <Row>

                    <Col>

                        <ListGroup>

                            {
                                uploadOverviewItems.map(i => {
                                    return (

                                        <ListGroupItem as={Link} to={i.link} key={i.label} className="d-flex bg-smoke  text-primary-dull">
                                                <span className="me-3 ">
                                                      {i.icon}
                                                </span>
                                            {i.label}
                                            <span className="ms-auto">  {i.value}</span>
                                        </ListGroupItem>

                                    )
                                })
                            }
                        </ListGroup>

                    </Col>
                    <Col xs={4} className="d-none d-sm-block d-md-none d-lg-block">
                        <div className="d-flex flex-column ">
                            <div className='d-flex justify-content-center'>
                                <div className="w-50">
                                    <CircularProgressbar
                                        value={25}
                                        text={<>{25}%</>}
                                        circleRatio={0.75}
                                        styles={buildStyles({
                                            rotation: 1 / 2 + 1 / 8,
                                            // strokeLinecap: "butt",
                                            trailColor: "#eee"
                                        })}
                                    />
                                </div>

                            </div>
                            <div className="text-center small">
                                Completed {25}% of your uploads
                            </div>

                        </div>
                    </Col>
                </Row>
            </div>
            {state.overlay}
        </div>
    );
}

export default Dashboard;